import { render } from "./CheckboxList.vue?vue&type=template&id=8abd6512&scoped=true"
import script from "./CheckboxList.vue?vue&type=script&lang=js"
export * from "./CheckboxList.vue?vue&type=script&lang=js"

import "./CheckboxList.vue?vue&type=style&index=0&id=8abd6512&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8abd6512"]])

export default __exports__
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';import Ripple from 'quasar/src/directives/ripple/Ripple.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QList,QItem,QItemSection,QIcon,QCheckbox,QBtn});qInstall(script, 'directives', {Ripple});
